<nav mat-tab-nav-bar class="mc-arrow-tabs">
  <a mat-tab-link [routerLink]="routerLinkCommand$ | async">
    <img class="mc-flare-online-link-logo" alt="Flare Online Logo" src="assets/images/madcap-flare-online-text-logo-white.svg">
  </a>
</nav>